import * as yup from "yup";

export const performanceMetricValidationSchema = yup.object({
  title: yup.string().required("Metric title is required"),
  description: yup.string().required("Description is required"),
  isActive: yup.boolean().required(),
});
